import { LoadingBackdrop_default } from './chunk-BAWCK7NB.mjs';

// src/universal/LoadingBackdrop/index.ts
var LoadingBackdrop_default2 = LoadingBackdrop_default;

export { LoadingBackdrop_default2 as LoadingBackdrop_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-75TYPDI4.mjs.map